/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import cogoToast from "cogo-toast";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreatAxios from "../../components/axiosComponent/create";
import { connect } from "react-redux";
import { MyInput, MyNormalInput } from "../dynamicComponent/myInputs";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";

const ModalMapDelivery = ({
  values,
  order,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
  role,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [refreshModal, setRefreshModal] = useState(false);

  const [selectedOrderNo, setSelectedOrderNo] = useState('');

  useEffect(() => {
    let orderContaningValue = 0;
    order.forEach(element => {
      if (element.common_order_number == null || element.common_order_number == undefined || element.common_order_number == 'NA') {
      } else if (orderContaningValue == 0) {
        let orderToClub = element.common_order_number;
        setSelectedOrderNo(orderToClub)
        setFieldValue('order_number', orderToClub)
      }
    });
  }, [order, refreshModal]);

  let handleOpen = () => {
    let orderContaningValue = 0;
    if (order.length <= 1) {
      cogoToast.error("Please select delivery with more than 1 order.")
    } else {
      order.forEach(element => {
        if (element.common_order_number == null || element.common_order_number == undefined || element.common_order_number == 'NA') {
        } else {
          orderContaningValue++;
        }
      });
      console.log(orderContaningValue)
      if (orderContaningValue == 0) {
        cogoToast.error("Please select delivery with order number.")
      }
      else {
        setmodalOpen(true);
      }
    }
  }
  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    if (order.length <= 1) {
      cogoToast.error("Please select more than 1 delivery.")
    } else {
      setmodalOpen(false);
      handleSubmit();
    }

  };

  /* const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
      })
      .catch((err) => setVendors([]));
  }; 

  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.transporterName,
        key: item.transporterCode,
        value: item.transporterMasterId,
      };
    });
    setVendors(result);
  };*/

  const handleInputChange = (e) => {
    console.log(e.target.value)
    setSelectedOrderNo(e.target.value)
  };

  const removeOrder = (e, orderToRemove, Index) => {
    order.splice(Index, 1);

    setRefreshModal(!refreshModal)
  };


  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="xl"
        trigger={
          <>
            <Button circular size="mini" animated disabled={role == "Broker" ? true : false} color="primary" className="w3-blue w3-round w3-hover-blue padding-tb-10 p-bolder" onClick={handleOpen}>
              <Button.Content visible>
                {t("action_button.add_deliveries") || "Add to Deliveries"}
                <Icon name='cart'></Icon>
                {order?.length ? order.length : ''}
              </Button.Content>
              <Button.Content hidden>
                <Icon name='cart'></Icon>
                {order?.length ? order.length : ''}
              </Button.Content>
            </Button>
          </>
        }
      >
        <Modal.Header className="p-bold-100">
          {t("modal_title") || "Club Deliveries"}
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <div className="ui form">

              <Table compact celled definition>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell className="no-border-top" />
                    <Table.HeaderCell>Delivery Number</Table.HeaderCell>
                    <Table.HeaderCell>Reference Number</Table.HeaderCell>
                    <Table.HeaderCell>Order Number</Table.HeaderCell>
                    <Table.HeaderCell>Consignor Name</Table.HeaderCell>
                    <Table.HeaderCell>Consignee Name</Table.HeaderCell>
                    <Table.HeaderCell>Billing Party</Table.HeaderCell>
                    <Table.HeaderCell>Billing Party Branch</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {order.map((item, index) => {
                    return (
                      <>
                        <Table.Row>
                          <Table.Cell collapsing>
                            <Icon name="minus circle" onClick={e => { removeOrder(e, item, index) }} />
                          </Table.Cell>
                          <Table.Cell>{item.delivery_no}</Table.Cell>
                          <Table.Cell>{item.order_no}</Table.Cell>
                          <Table.Cell>{item.common_order_number}</Table.Cell>
                          <Table.Cell>{item.consignor_name}</Table.Cell>
                          <Table.Cell>{item.consignee_name}</Table.Cell>
                          <Table.Cell>{item.billing_party_name}</Table.Cell>
                          <Table.Cell>{item.billing_party_branch_name}</Table.Cell>
                        </Table.Row>
                      </>
                    )
                  })}
                </Table.Body>
              </Table>

              <FormUi.Field width={12}>
                <label className="labelName mt-4">
                  {t("order_club") || "To Club with : Order Number"}
                </label>
                <Fieldmik
                  component={MyNormalInput}
                  type="text"
                  name="order_number"
                  value={selectedOrderNo}
                  onChange={(e) => { handleInputChange(e); setFieldValue('order_number', e.target.value) }}
                />
              </FormUi.Field>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting || values.vendor ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("club_submit") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikModalMapDelivery = withFormik({
  mapPropsToValues() {
    return {
      order_number: null,
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    let delivery_ids = [];
    let data = props.order;
    for (let index = 0; index < data.length; index++) {
      delivery_ids.push(data[index].delivery_id);
    }
    let payload = { delivery_ids: delivery_ids, ...values };

    CreatAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/deliveries/club`,
      payload,
    })
      .then((res) => {
        console.log(res);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        window.location.reload();
      })
      .catch((err) => {
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.response.data.message, //err.response.data.message[0],
        });
      });
  },
})(ModalMapDelivery);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("deliverylist")(FormikModalMapDelivery)
);
